import styled from "styled-components";
export const FlagImage = styled.img`
  display: flex;
  justify-content: center;
  width: 5%;
  border: none;
  // height: auto;
  // margin-bottom: 20px;
  z-index: 9999;
  // position: absolute;
`;

export const Image = styled.img`
  cursor: zoom-in;
  max-height: 350px;
`;

export const Modal = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  padding: 10px;
`;

export const Close = styled.span`
  color: white;
  font-weight: bold;
  position: absolute;
  right: 40px;
  top: 20px;
  font-size: 30px;
  cursor: pointer;
`;
